
import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

// Composant de chargement ultra-léger
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="w-10 h-10 border-4 border-[#00B4D8] border-t-transparent rounded-full animate-spin"></div>
  </div>
);

// Lazy loading des pages
const Home = lazy(() => import('../pages/home/page'));
const Prestations = lazy(() => import('../pages/prestations/page'));
const Confiance = lazy(() => import('../pages/confiance/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Galerie = lazy(() => import('../pages/galerie/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Wrapper avec Suspense
const withSuspense = (Component: React.LazyExoticComponent<() => JSX.Element>) => (
  <Suspense fallback={<PageLoader />}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: withSuspense(Home),
  },
  {
    path: '/prestations',
    element: withSuspense(Prestations),
  },
  {
    path: '/confiance',
    element: withSuspense(Confiance),
  },
  {
    path: '/contact',
    element: withSuspense(Contact),
  },
  {
    path: '/galerie',
    element: withSuspense(Galerie),
  },
  {
    path: '*',
    element: withSuspense(NotFound),
  },
];

export default routes;
